unit PrjClassTokenInformation;

interface

uses
  System.SysUtils,
  System.Classes,
  System.Rtti,
  System.TypInfo,
  System.StrUtils,
  System.Types,
  System.Generics.Collections,
  JS,
  Web,
  WEBLib.Modules,
  WEBLib.REST,
  WEBLib.Controls,
  WebLib.ExtCtrls,
  Data.DB,
  XData.Web.Connection,
//  XData.Web.JsonDataset,
  XData.Web.Dataset,
  XData.Web.Client;


type
  TTokenInformation = class(TPersistent)
  strict private
  private
    FAccessInfo: string;
    FAktEnterprise: integer;
    FCopyDescision: Boolean;
    FErrorInfo: string;
    FExpires: string;
    FFirstName: string;
    FisAdministrator: Boolean;
    FisCalculated: Boolean;
    FisSpielleiter: Boolean;
    FIssuer: string;
    FisTeilnehmer: Boolean;
    FisValidToken: Boolean;
    FLastEnterprise: integer;
    FLastName: string;
    FLastPeriodId: integer;
    FMaxEnterprise: integer;
    FMinEnterprise: integer;
    FOriginalToken: string;
    FPeriodId: integer;
    FReqNewPwd: integer;
    FSeminarDate: TDateTime;
    FSeminarName: string;
    FSimulationID: integer;
    FUserID: Integer;
    FToken: TJSObject;
    FTokenStorageName: string;
    FUserName: string;
    FValidUntil: TDateTime;
    function GetAccessInfo: string;
    function GetAktEnterprise: integer;
    function GetCopyDescision: Boolean;
    function GetErrorInfo: string;
    function GetExpires: string;
    function GetFirstName: string;
    function GetisAdministrator: Boolean;
    function GetisCalculated: Boolean;
    function GetisSpielleiter: Boolean;
    function GetIssuer: string;
    function GetisTeilnehmer: Boolean;
    function GetisValidToken: Boolean;
    function GetLastEnterprise: integer;
    function GetLastName: string;
    function GetLastPeriodId: integer;
    function GetMaxEnterprise: integer;
    function GetMinEnterprise: integer;
    function GetPeriodId: integer;
    function GetReqNewPwd: integer;
    function GetSeminarDate: TDateTime;
    function GetSeminarName: string;
    function GetSimulationID: integer;
    function GetUserID: Integer;
    function GetUserName: string;
  public
    function BuildJWTStorageName(AToken: string): string; virtual;
    procedure WriteTokenInfo;
  published
    property TokenStorageName: string read FTokenStorageName write FTokenStorageName;
    property AccessInfo: string read GetAccessInfo;
    property FirstName: string read GetFirstName;
    property isAdministrator: Boolean read GetisAdministrator;
    property isSpielleiter: Boolean read GetisSpielleiter;
    property Issuer: string read GetIssuer;
    property isTeilnehmer: Boolean read GetisTeilnehmer;
    property LastName: string read GetLastName;
    property Token: TJSObject read FToken write FToken;
    property UserID: Integer read GetUserID;
    property UserName: string read GetUserName;
    property ErrorInfo: string read GetErrorInfo;
    property SimulationID: integer read GetSimulationID;
    property ReqNewPwd: integer read GetReqNewPwd;
    property Expires: string read GetExpires;
    property SeminarName: string read GetSeminarName;
    property PeriodId: integer read GetPeriodId;
    property LastPeriodId: integer read GetLastPeriodId;
    property AktEnterprise: integer read GetAktEnterprise;
    property LastEnterprise: integer read GetLastEnterprise;
    property MaxEnterprise: integer read GetMaxEnterprise;
    property MinEnterprise: integer read GetMinEnterprise;
    property isCalculated: Boolean read GetisCalculated;
    property SeminarDate: TDateTime read GetSeminarDate;
    property CopyDescision: Boolean read GetCopyDescision;
    property isValidToken: Boolean read GetisValidToken;
    property OriginalToken: string read FOriginalToken write FOriginalToken;
  end;


implementation

uses
  weblib.WebTools,
  wxBaseClassWebTools,
  PrjConstants,
  HBMWebData,
  HBMWebDef;



function TTokenInformation.BuildJWTStorageName(AToken: string): string;
begin
  if (AToken <> '')  then
  begin
    Self.FToken             := TJSObject(TJSJSON.parseObject(Window.atob(Copy(AToken, Pos('.', AToken) + 1, LastDelimiter('.', AToken)-Pos('.', AToken) - 1))));
    Self.FTokenStorageName  := 'HBM-Online-' + Self.UserID.ToString + '-' + Self.UserName;
    Result                  := Self.FTokenStorageName;
    FOriginalToken          := AToken;
  end else
  begin
    Result := 'no or invalid Token passed [' + AToken + ']';
    wxBaseWriteLog.Write('no or invalid Token passed [' + AToken + ']', slDebug);
  end;
end;

function TTokenInformation.GetAccessInfo: string;
begin
  if FToken.hasOwnProperty(cJWTClaimAccessInfo) then
  begin
    FAccessInfo :=  string(FToken.properties[cJWTClaimAccessInfo]);
  end;
  Result := FAccessInfo;
end;

function TTokenInformation.GetAktEnterprise: integer;
begin
  if FToken.hasOwnProperty(cJWTClaimAktEnterprise) then
  begin
    FAktEnterprise := integer(FToken.properties[cJWTClaimAktEnterprise]);
  end else
    FAktEnterprise := -1;
  Result := FAktEnterprise;
end;

function TTokenInformation.GetCopyDescision: Boolean;
begin
  if FToken.hasOwnProperty(cJWTClaimCopyDescision) then
  begin
    FCopyDescision :=  integer(FToken.properties[cJWTClaimCopyDescision]) = 1;
  end else
    FCopyDescision := false;
  Result := FCopyDescision;
end;

function TTokenInformation.GetErrorInfo: string;
begin
  if FToken.hasOwnProperty(cJWTClaimErrorInfo) then
  begin
    FErrorInfo :=  string(FToken.properties[cJWTClaimErrorInfo]);
  end;
  Result := FErrorInfo;
end;

function TTokenInformation.GetExpires: string;
begin
  if FToken.hasOwnProperty(cJWTClaimExpiration) then
  begin
    FExpires := string(FToken.properties[cJWTClaimExpiration]);
  end else
  begin
    FExpires := FormatDateTime('dd.mm.yyyy hh:nn:ss', Now + cTokenExpirationTime);
  end;
  Result := FExpires;
end;

function TTokenInformation.GetFirstName: string;
begin
  if FToken.hasOwnProperty(cJWTClaimFirstName) then
  begin
    FFirstName :=  string(FToken.properties[cJWTClaimFirstName]);
  end;
  Result := FFirstName;
end;

function TTokenInformation.GetisAdministrator: Boolean;
begin
  if FToken.hasOwnProperty(cJWTClaimisAdministrator) then
  begin
    FisSpielleiter :=  integer(FToken.properties[cJWTClaimisAdministrator]) = 1;
  end else
    FisSpielleiter := false;
  Result := FisAdministrator;
end;

function TTokenInformation.GetisSpielleiter: Boolean;
begin
  if FToken.hasOwnProperty(cJWTClaimisSpielleiter) then
  begin
    FisSpielleiter :=  integer(FToken.properties[cJWTClaimisSpielleiter]) = 1;
  end;
  Result := FisSpielleiter;
end;

function TTokenInformation.GetIssuer: string;
begin
  if FToken.hasOwnProperty('iss') then
  begin
    FIssuer := string(FToken.properties['iss']);
  end;
  Result := FIssuer;
end;

function TTokenInformation.GetisTeilnehmer: Boolean;
begin
  if FToken.hasOwnProperty(cJWTClaimisTeilnehmer) then
  begin
    FisTeilnehmer := integer(FToken.properties[cJWTClaimisTeilnehmer]) = 1;
  end else
    FisTeilnehmer := false;
  Result := FisTeilnehmer;
end;

function TTokenInformation.GetLastName: string;
begin
  if FToken.hasOwnProperty(cJWTClaimLastName) then
  begin
    FLastName := string(FToken.properties[cJWTClaimLastName]);
  end;
  Result := FLastName;
end;

function TTokenInformation.GetReqNewPwd: integer;
begin
  if FToken.hasOwnProperty(cJWTClaimRequestNewPassword) then
  begin
    FReqNewPwd := Integer(FToken.properties[cJWTClaimRequestNewPassword]);
  end;
  Result := FReqNewPwd;
end;

function TTokenInformation.GetSimulationID: integer;
begin
  if FToken.hasOwnProperty(cJWTClaimSimulationId) then
  begin
    FSimulationID := integer(FToken.properties[cJWTClaimSimulationId]);
  end else
  begin
    FSimulationID := -1;
  end;
  Result := FSimulationID;
end;

function TTokenInformation.GetisCalculated: Boolean;
begin
  if FToken.hasOwnProperty(cJWTClaimisCalculated) then
  begin
    FisCalculated := integer(FToken.properties[cJWTClaimisCalculated]) = 1;
  end else
  begin
    FisCalculated := false;
  end;
  Result := FisCalculated;
end;

function TTokenInformation.GetisValidToken: Boolean;
var LExpireDate : TDateTime;
begin
  try
    if FToken.hasOwnProperty(cJWTClaimExpiration) then
    begin
      FExpires := string(FToken.properties[cJWTClaimExpiration]);
      if not TryStrToDateTime(FExpires, LExpireDate) then
        FisValidToken := false
      else
      begin
        FisValidToken := Now <= LExpireDate;
      end;
    end else
    begin
      FisValidToken := false;
    end;
    Result := FisValidToken;
  except
    FisValidToken := false;
    Result := FisValidToken;
  end;
end;

function TTokenInformation.GetLastEnterprise: integer;
begin
  if FToken.hasOwnProperty(cJWTClaimLastEnterprise) then
  begin
    FLastEnterprise := integer(FToken.properties[cJWTClaimLastEnterprise]);
  end else
  begin
    FLastEnterprise := -1;
  end;
  Result := FLastEnterprise;
end;

function TTokenInformation.GetLastPeriodId: integer;
begin
  if FToken.hasOwnProperty(cJWTClaimLastPeriodId) then
  begin
    FLastPeriodId := integer(FToken.properties[cJWTClaimLastPeriodId]);
  end else
  begin
    FLastPeriodId := -1;
  end;
  Result := FLastPeriodId;
end;

function TTokenInformation.GetMaxEnterprise: integer;
begin
  if FToken.hasOwnProperty(cJWTClaimMaxEnterprise) then
  begin
    FMaxEnterprise := integer(FToken.properties[cJWTClaimMaxEnterprise]);
  end else
  begin
    FMaxEnterprise := -1;
  end;
  Result := FMaxEnterprise;
end;

function TTokenInformation.GetMinEnterprise: integer;
begin
  if FToken.hasOwnProperty(cJWTClaimMinEnterprise) then
  begin
    FMinEnterprise := integer(FToken.properties[cJWTClaimMinEnterprise]);
  end else
  begin
    FMinEnterprise := -1;
  end;
  Result := FMinEnterprise;
end;

function TTokenInformation.GetPeriodId: integer;
begin
  if FToken.hasOwnProperty(cJWTClaimPeriodId) then
  begin
    FPeriodId := integer(FToken.properties[cJWTClaimPeriodId]);
  end else
  begin
    FPeriodId := -1;
  end;
  Result := FPeriodId;
end;

function TTokenInformation.GetSeminarDate: TDateTime;
begin
  if FToken.hasOwnProperty(cJWTClaimSeminarDate) then
  begin
    FSeminarDate := StrToDate(string(FToken.properties[cJWTClaimSeminarDate]));
  end else
  begin
    FSeminarDate := -1;
  end;
  Result := FSeminarDate;
end;

function TTokenInformation.GetSeminarName: string;
begin
  if FToken.hasOwnProperty(cJWTClaimSeminarName) then
  begin
    FSeminarName := string(FToken.properties[cJWTClaimSeminarName]);
  end else
  begin
    FSeminarName := 'no Seminar Name';
  end;
  Result := FSeminarName;
end;

function TTokenInformation.GetUserID: Integer;
begin
  if FToken.hasOwnProperty(cJWTClaimUserId) then
  begin
    FUserID := integer(FToken.properties[cJWTClaimUserId]);
  end else
  begin
    FUserID := -1;
  end;
  Result := FUserID;
end;

function TTokenInformation.GetUserName: string;
begin
  if FToken.hasOwnProperty(cJWTClaimUserName) then
  begin
    FUserName := string(FToken.properties[cJWTClaimUserName]);
  end;
  Result := FUserName;
end;

procedure TTokenInformation.WriteTokenInfo;
begin
  console.log('FAccessInfo : ' + AccessInfo);
  console.log('FErrorInfo : ' + ErrorInfo);
  console.log('FExpires : ' + Expires);
  console.log('FFirstName : ' + FirstName);
  console.log('FisAdministrator : ' + isAdministrator.ToInteger.ToString);
  console.log('FisSpielleiter : ' + isSpielleiter.ToInteger.ToString);
  console.log('FIssuer : ' + Issuer);
  console.log('FisTeilnehmer : ' + isTeilnehmer.ToInteger.ToString);
  console.log('FLastName : ' + LastName);
  console.log('FReqNewPwd : ' + ReqNewPwd.ToString);
  console.log('FSimulationID : ' + SimulationID.ToString);
  console.log('FUserID : ' + UserID.ToString);
  console.log('FTokenStorageName : ' + TokenStorageName);
  console.log('SeminarName :  ' + SeminarName);
  console.log('PeriodId :  ' + PeriodId.ToString);
  console.log('LastPeriodId :  ' + LastPeriodId.ToString);
  console.log('AktEnterprise :  ' + AktEnterprise.ToString);
  console.log('LastEnterprise :  ' + GetLastEnterprise.ToString);
  console.log('MaxEnterprise :  ' + MaxEnterprise.ToString);
  console.log('MinEnterprise :  ' + MinEnterprise.ToString);
//  console.log('isCalculated :  ' + isCalculated.ToString);
//  console.log('SeminarDate :  ' + DateToStr(SeminarDate));
//  console.log('CopyDescision :  ' + CopyDescision.ToString);
//  console.log('DeleteData :  ' + DeleteData.ToString);;
//  console.log('DeleteMVZ :  ' + DeleteMVZ.ToString);
end;

end.
